import type { ReactNode } from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@groot/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@groot/ui/dropdown-menu";

/** Trailing "⋯" menu for a table row, composed from the groot dropdown menu. */
export function RowActions({ children }: { children: ReactNode }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" className="text-muted-foreground">
          <MoreHorizontal className="size-4" />
          <span className="sr-only">Open actions</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

interface RowActionItemProps {
  children: ReactNode;
  onClick?: () => void;
  destructive?: boolean;
  disabled?: boolean;
  asChild?: boolean;
}

export function RowActionItem({
  children,
  onClick,
  destructive,
  disabled,
  asChild,
}: RowActionItemProps) {
  return (
    <DropdownMenuItem
      onClick={onClick}
      disabled={disabled}
      asChild={asChild}
      variant={destructive ? "destructive" : "default"}
    >
      {children}
    </DropdownMenuItem>
  );
}

export function RowActionSeparator() {
  return <DropdownMenuSeparator />;
}
